import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Phone, Menu, X, HeartPulse } from 'lucide-react';
import { useSettings } from '../../context/SettingsContext';
import api from '../../utils/api';
import './Header.css';

const DEFAULT_NAV = [
  { id:'d1', label:'Ballina',       url:'/',              sort_order:0  },
  { id:'d2', label:'Departamentet', url:'/departamentet', sort_order:5  },
  { id:'d3', label:'Shërbimet',     url:'/sherbimet',     sort_order:6  },
  { id:'d4', label:'Lajmet',        url:'/lajmet',        sort_order:7  },
  { id:'d5', label:'Publikimet',    url:'/publikimet',    sort_order:8  },
  { id:'d6', label:'Udhëheqja',    url:'/udheheqja',    sort_order:9  },
  { id:'d7', label:'Kontakti',      url:'/kontakti',      sort_order:99 },
];

export default function Header() {
  const s = useSettings();
  const [open,     setOpen]     = useState(false);
  const [navItems, setNavItems] = useState(DEFAULT_NAV);

  useEffect(() => {
    api.get('/nav-items')
      .then(r => {
        const data = r.data;
        if (Array.isArray(data) && data.length > 0) {
          setNavItems(data);
        }
        // nëse array bosh ose jo-array → mbaj DEFAULT_NAV
      })
      .catch(() => {
        // API nuk ka tabelën nav_items ende → mbaj DEFAULT_NAV
      });
  }, []);

  const isInternal = (url) => !url || url.startsWith('/') || url.startsWith('#');

  return (
    <header className="site-header">
      <div className="topbar">
        <div className="container topbar-inner">
          <span className="topbar-left">
            📅 {new Date().toLocaleDateString('sq-AL', { day:'numeric', month:'long', year:'numeric' })}
          </span>
          <a href={`tel:${s.emergency_phone}`} className="emergency-badge">
            <Phone size={12}/>
            Emergjenca 24h: {s.emergency_phone || '+383 45 104 230'}
          </a>
        </div>
      </div>

      <div className="navbar">
        <div className="container navbar-inner">
          <Link to="/" className="logo">
            {s.logo
              ? <img
                  src={`${process.env.REACT_APP_IMG_URL || 'http://localhost:5000'}${s.logo}`}
                  alt="Logo" className="logo-img"
                />
              : <div className="logo-icon"><HeartPulse size={22}/></div>
            }
            <div className="logo-text">
              <span className="logo-name">{s.site_name || 'Spitali i Prizrenit'}</span>
              {s.site_subtitle && <span className="logo-sub">{s.site_subtitle}</span>}
            </div>
          </Link>

          <nav className={`nav-links ${open ? 'open' : ''}`}>
            {[...navItems]
              .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0))
              .map(item => (
                isInternal(item.url) ? (
                  <NavLink
                    key={item.id}
                    to={item.url || '/'}
                    end={item.url === '/'}
                    className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                    onClick={() => setOpen(false)}
                  >
                    {item.label}
                  </NavLink>
                ) : (
                  <a
                    key={item.id}
                    href={item.url}
                    className="nav-link"
                    onClick={() => setOpen(false)}
                    target={item.opens_blank ? '_blank' : '_self'}
                    rel="noreferrer"
                  >
                    {item.label}
                  </a>
                )
              ))
            }
          </nav>

          <button className="hamburger" onClick={() => setOpen(v => !v)} aria-label="Menu">
            {open ? <X size={22}/> : <Menu size={22}/>}
          </button>
        </div>
      </div>
    </header>
  );
}
